import { render, staticRenderFns } from "./CustomStatCardMain.vue?vue&type=template&id=4e3b3d0d&scoped=true&"
import script from "./CustomStatCardMain.vue?vue&type=script&lang=ts&"
export * from "./CustomStatCardMain.vue?vue&type=script&lang=ts&"
import style0 from "./CustomStatCardMain.vue?vue&type=style&index=0&id=4e3b3d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b3d0d",
  null
  
)

export default component.exports